export default "__VITE_ASSET__V38H1S3d__"